(function () {
  'use strict';

  angular.module('app').component('documentTypeDetail', documentTypeDetail());

  function documentTypeDetail() {
    return {
      bindings: {
        item: '=',
        mode: '<',
        onDocumentTypeSaved: '&',
        onDocumentTypeCanceled: '&',
        defaultLanguage: '<',
        additionalLanguages: '<',
      },
      controller: DocumentTypeDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/document-types/document-type-detail/document-type-detail.component.html',
    };
  }

  DocumentTypeDetailComponent.$inject = ['CONFIGURATIONS', 'UtilService', 'DocumentTypeService'];

  function DocumentTypeDetailComponent(config, UtilService, DocumentTypeService) {
    const vm = this;

    // public properties
    // ----------------------
    vm.UtilService = new UtilService(vm);

    const fieldsDefinition = [
      'name',
      'numbering_type',
      'prefix',
      'length',
      'starting_number',
      'transaction_type',
      'allows_repeated',
      'allows_future_days',
      'allows_past_days',
      'ticket_printing',
      // 'client_required'
    ];

    vm.transactionTypes = config.TRANSACTION_TYPES;
    vm.minLength = 6;

    vm.$onInit = function () {
      if (vm.item.id) {
        // show - edit
        setItemOptions(vm.item, vm.mode);
      } else {
        // new
        vm.createMode = true;

        vm.item = {
          allows_repeated: false,
          allows_future_days: false,
          allows_past_days: false,
          ticket_printing: false,
          // client_required:    true
        };

        // recipient confirmation is only for view and edit mode
        vm.transactionTypes = vm.transactionTypes.filter(
          (item) => item.value !== 'recipient_confirmation'
        );
      }
    };

    // public methods
    // -----------------------
    vm.editDocumentType = function () {
      vm.editMode = true;
      vm.viewMode = false;

      vm.transactionTypes.forEach((transactionType) => {
        if (transactionType.value === vm.item.transaction_type) {
          vm.numberingOptions = transactionType.numberingOptions;
          return vm.numberingOptions;
        }
      });
    };

    vm.cancelEdit = function () {
      vm.item = vm.originalItem;
      setItemOptions(vm.item);
    };

    vm.openTranslations = function () {
      DocumentTypeService.openDocumentTypeTranslations(vm.item, vm.additionalLanguages);
    };

    vm.selectTransactionType = function (transactionType) {
      //if (vm.transactionTypeSelected === transactionType) {
      //    return;
      //}

      vm.transactionTypeSelected = transactionType;

      vm.item.numbering_type = null;
      vm.item.prefix = null;
      vm.item.starting_number = null;

      vm.numberingOptions = transactionType.numberingOptions;
    };

    vm.selectNumberingType = function (numberingType) {
      if (vm.numberingTypeSelected === numberingType) return;

      if (numberingType === 'electronic') {
        vm.item.allows_future_days = false;
        vm.item.allows_past_days = false;
      }

      vm.numberingTypeSelected = numberingType;

      vm.item.prefix = null;
      vm.item.starting_number = null;

      if (vm.createMode) {
        vm.item.length = 6;
      }
    };

    // Is the starting number is evaluated but less than 6.
    // set the length to 6
    vm.setMinLength = function (starting_number) {
      let minLength = 6;

      if (starting_number && starting_number.length > 6) {
        minLength = starting_number.length;
      }

      vm.minLength = minLength;

      return minLength;
    };

    // Create/Update
    vm.saveDocumentType = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      if (vm.UtilService.isFormDataChanged(vm.item, vm.originalItem, fieldsDefinition)) {
        vm.sendingForm = true;
        DocumentTypeService.saveDocumentType(vm.item, vm.defaultLanguage).then(function (data) {
          let status = data.status;
          let response = data.response;

          if (status) {
            // Success
            setItemOptions(response);
            vm.onDocumentTypeSaved({ item: response });
          } else {
            vm.serverErrors = vm.UtilService._showItemServerErrors(response.errors);
            vm.formErrors = true;
          }

          vm.sendingForm = false;
        });
      } else {
        vm.cancel();
      }
    };

    vm.cancel = function () {
      vm.onDocumentTypeCanceled();
    };

    // private methods
    // -----------------------
    function setItemOptions(item, mode = '') {
      vm.createMode = false;
      vm.editMode = false;
      vm.viewMode = true;

      if (mode === 'edit') {
        vm.editDocumentType();
      }

      // if (!item.client_required) { // hack for new field added in DB
      //     item.client_required = false;
      // }

      vm.itemName = vm.item.name;

      vm.originalItem = angular.copy(item); // store server data
    }
  }
})();
